import cab from "../images/funciones/taxi.png";
import brain from "../images/funciones/neurocognitivo.png";

const funcionalidadesBig = {
  neuro: {
    image: { brain },
    title: "Funciones Cognitivas",
    sub: "Pronto vas a poder acceder a nuestra plataforma de evaluación y ejercitación neuro-cognitiva, lo que te va a permitir saber cómo estás, y prevenir o ralentizar cualquier deterioro neuro-cognitivo. ¡Por una mente más ágil y rápida!",
  },
  taxi: {
    image: { cab },
    title: "Ellie Taxi",
    sub: "Aún hay mucho por descubrir, mucho para recorrer, y muchos amigos para visitar y pasarla bien. Pronto vas a poder acceder a nuestra nueva plataforma de movilidad y transporte.",
  },
};

export default funcionalidadesBig;
